<template>
  <div v-if="loaded">
    <h4 class="font-bold text-gray-800 mt-8">Recent Pipeline Reviews</h4>
    <ZeroState v-if="!pipelineReviews.length"> No pipeline reviews yet. </ZeroState>
    <div v-else>
      <PreviousPipelineReviewCard
        v-for="pipelineReview in pipelineReviews"
        :key="`pipelineReview-${pipelineReview.id}`"
        :pipeline-review="pipelineReview"
        :teammate="teammate"
      />
    </div>
  </div>
</template>

<script>
import ZeroState from '../ZeroState.vue';
import PreviousPipelineReviewCard from './PreviousPipelineReviewCard.vue';
import { formatStandardDate } from '../../utilities/format.js';

export default {
  components: {
    ZeroState,
    PreviousPipelineReviewCard,
  },
  props: {
    teammate: {
      type: Object,
      required: true,
    },
    contactEvent: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    await this.fetchHistory();
  },
  data() {
    return {
      pipelineReviews: [],
      loaded: false,
    };
  },
  methods: {
    async fetchHistory() {
      const res = await fetch(`/api/contacts/${this.teammate.id}/pipeline_reviews`);
      const data = await res.json();

      this.pipelineReviews = data.filter(pr => pr.contact_event_id !== this.contactEvent.id);
      this.loaded = true;
    },
    formatDate(date) {
      return formatStandardDate(date);
    },
  },
};
</script>
